var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandardClogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 265.48 59.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath);}.cls-2{fill:none;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17{stroke-width:0px;}.cls-3{fill:url(#Gradiente_sem_nome_121-4);}.cls-4{fill:url(#Gradiente_sem_nome_121-5);}.cls-5{fill:url(#Gradiente_sem_nome_121-6);}.cls-6{fill:url(#Gradiente_sem_nome_121-7);}.cls-7{fill:url(#Gradiente_sem_nome_121-2);}.cls-8{fill:url(#Gradiente_sem_nome_121-3);}.cls-9{fill:url(#Gradiente_sem_nome_121-8);}.cls-10{fill:url(#Gradiente_sem_nome_120-2);}.cls-18{clip-path:url(#clippath-1);}.cls-19{clip-path:url(#clippath-4);}.cls-20{clip-path:url(#clippath-3);}.cls-21{clip-path:url(#clippath-2);}.cls-22{clip-path:url(#clippath-7);}.cls-23{clip-path:url(#clippath-8);}.cls-24{clip-path:url(#clippath-6);}.cls-25{clip-path:url(#clippath-5);}.cls-26{clip-path:url(#clippath-9);}.cls-27{clip-path:url(#clippath-13);}.cls-28{clip-path:url(#clippath-12);}.cls-29{clip-path:url(#clippath-10);}.cls-30{clip-path:url(#clippath-11);}.cls-11{fill:url(#Gradiente_sem_nome_109);}.cls-12{fill:url(#Gradiente_sem_nome_108);}.cls-13{fill:url(#Gradiente_sem_nome_115);}.cls-14{fill:url(#Gradiente_sem_nome_121);}.cls-15{fill:url(#Gradiente_sem_nome_120);}.cls-16{fill:url(#Gradiente_sem_nome_122);}.cls-17{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m6.38,1.87C3.55,2.47,1.47,4.89,1.18,7.92.56,14.62-.4,26.67.18,32.02c1.36,12.63,10.16,22.51,24.15,27.1l1.25.41,1.32-.43c10.31-3.28,22.05-12.09,24.08-26.97.66-4.86-.11-14.75-.95-23.78l-.04-.44c-.28-3.02-2.37-5.45-5.21-6.04C38.14.5,31.69-.2,25.59-.2S13.03.5,6.38,1.87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_108",
    x1: -4784.79,
    y1: 2615.14,
    x2: -4784.11,
    y2: 2615.14,
    gradientTransform: "translate(-232659.23 425727.45) rotate(90) scale(88.98 -88.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#405caa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#405caa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#324d9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#32479a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#263775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#21305f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21305f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m7.42,5.44c-1.16.24-1.89,1.26-2,2.47-.47,5.05-1.57,18.08-1.01,23.3,1.27,11.79,9.81,19.56,20,23.36.51.19,1.02.37,1.53.54.1-.04,3.52-.98,3.52-.98.68-.34,2.89-1.39,3.56-1.83,6.54-4.29,12.2-13,14.18-21.09,1.25-5.1-.54-18.25-1.01-23.3-.11-1.2-.85-2.22-2.01-2.47-3.18-.66-10.17-1.99-18.38-1.99s-15.2,1.33-18.38,1.99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_109",
    x1: -4778,
    y1: 2620.67,
    x2: -4777.32,
    y2: 2620.67,
    gradientTransform: "translate(-198639.8 362207.06) rotate(90) scale(75.81 -75.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f8ecc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3f8ecc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3c82c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#3662ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#324d9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#2d458d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#21305f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21305f"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m42.74,31.04c-.56,5.26-2.86,9.89-6.28,13.32l.63-.63c3.42-3.43,6.03-7.28,6.3-13.27l-.65.58Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_120",
    x1: -4452.19,
    y1: 2738.88,
    x2: -4451.52,
    y2: 2738.88,
    gradientTransform: "translate(45575.85 28052.09) scale(10.23 -10.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#dcdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#c9c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3c2c2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m14.42,8.18l-.63.63c3.23-.45,7.19-.83,11.51-.83,6.96,0,13.02.99,16.46,1.66l.65-.65s-7-1.71-16.49-1.71c-3.56,0-7.47.24-11.5.9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_121",
    x1: -4715.44,
    y1: 2613.2,
    x2: -4714.76,
    y2: 2613.2,
    gradientTransform: "translate(199241.56 110416.51) scale(42.25 -42.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3c2c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#c9c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#dcdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m14.99,15.24l-.63.63c1.88-1.07,4.15-1.6,6.47-1.6.27,0,.54,0,.81.02,4.11.21,6.94,2.96,11.86,3.22.27.01.53.02.78.02,3.55,0,6.06-1.27,7.95-2.32l.63-.63c-1.9,1.05-4.4,2.32-7.95,2.32-.26,0-.52,0-.78-.02-4.92-.26-7.76-3-11.87-3.22-.27-.01-.54-.02-.81-.02-2.32,0-4.58.53-6.47,1.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_121-2",
    x1: -4715.15,
    y1: 2613.42,
    x2: -4714.48,
    y2: 2613.42,
    gradientTransform: "translate(198546.42 110053.86) scale(42.11 -42.11)",
    xlinkHref: "#Gradiente_sem_nome_121"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m35.46,33.78c-3.76,0-6.08-1.51-8.05-2.12l-.63.63c1.97.62,4.29,2.12,8.05,2.12s6.68-2.14,7.9-3.27l.63-.63c-1.22,1.13-4.29,3.27-7.9,3.27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_121-3",
    x1: -4654.33,
    y1: 2642.53,
    x2: -4653.65,
    y2: 2642.53,
    gradientTransform: "translate(113904.64 64687.52) scale(24.47 -24.47)",
    xlinkHref: "#Gradiente_sem_nome_121"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m42.24,15.2c.22,2.89.43,6.09.53,8.98l.05,2.86.68-.61s0-7.29-.64-11.85l-.63.63Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_121-4",
    x1: -2903.44,
    y1: 3472.11,
    x2: -2902.77,
    y2: 3472.11,
    gradientTransform: "translate(5482.53 6526.62) scale(1.87 -1.87)",
    xlinkHref: "#Gradiente_sem_nome_121"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m33.63,51.67l-.63.63c2.38-1.39,4.57-3.05,6.48-4.96.21-.21.42-.42.62-.63-1.91,1.91-4.1,3.57-6.48,4.96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_115",
    x1: -4460.74,
    y1: 2735.29,
    x2: -4460.06,
    y2: 2735.29,
    gradientTransform: "translate(46830.85 28745.56) scale(10.49 -10.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3c2c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#d9d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#eeeded"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "21.44 29.58 33.01 52.3 33.63 51.67 22.07 28.95 21.44 29.58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_121-5",
    x1: -4601.91,
    y1: 2667.55,
    x2: -4601.23,
    y2: 2667.55,
    gradientTransform: "translate(82858.85 48058.33) scale(18 -18)",
    xlinkHref: "#Gradiente_sem_nome_121"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.04 20.21 23.1 50.32 23.86 49.69 8.67 19.45 8.04 20.21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_121-6",
    x1: -4646.97,
    y1: 2645.89,
    x2: -4646.29,
    y2: 2645.89,
    gradientTransform: "translate(108504.06 61810.37) scale(23.35 -23.35)",
    xlinkHref: "#Gradiente_sem_nome_121"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m5.51,6.39c-.46.47-.75,1.12-.82,1.84-.38,4.11-1.18,13.46-1.18,19.7,0,1.5.05,2.83.16,3.85,1.35,12.51,10.67,20.35,21.63,23.96l.63-.63c-10.97-3.6-20.28-11.45-21.63-23.96-.11-1.02-.16-2.35-.16-3.85,0-6.24.8-15.59,1.18-19.7.07-.72.35-1.37.82-1.84l-.63.63Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_121-7",
    x1: -4692.16,
    y1: 2624.4,
    x2: -4691.48,
    y2: 2624.4,
    gradientTransform: "translate(155610.37 87064.3) scale(33.16 -33.16)",
    xlinkHref: "#Gradiente_sem_nome_121"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m41.77,9.64c.05.58.13,1.28.18,1.97l.63-.63c0-.7-.16-1.99-.16-1.99l-.65.65Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_120-2",
    x1: -4365.58,
    y1: 1654.59,
    x2: -4364.9,
    y2: 1654.59,
    gradientTransform: "translate(6440.57 -16870.33) rotate(-90) scale(3.87 -3.87)",
    xlinkHref: "#Gradiente_sem_nome_120"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m9.29,8.73l-.63.63c.1-.1.24-.17.4-.17.12,0,.24.04.33.1l4.52,3.41c.29.22.44.56.44.91v2.26s.65-.64.65-.64l-.02-2.28c0-.35-.16-.65-.45-.87l-4.52-3.41c-.09-.07-.22-.1-.34-.1-.16,0-.3.06-.4.17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_121-8",
    x1: -4418.89,
    y1: 2752.76,
    x2: -4418.22,
    y2: 2752.76,
    gradientTransform: "translate(41410.42 25803.57) scale(9.37 -9.37)",
    xlinkHref: "#Gradiente_sem_nome_121"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m43.36,30.51l-.02.18c-.67,6.27-3.76,11.24-8.35,14.92l-6.31-12.34c-.47-.91-1.19-1.54-1.28-1.61,1.97.62,4.29,2.12,8.05,2.12s6.68-2.14,7.9-3.27m-20.7,18.7c-7.67-3.71-13.2-9.89-14.13-18.52-.25-2.37-.12-6.7.14-11.11l15.06,30.12c-.36-.16-.72-.32-1.07-.49M14.42,8.18c3.23-.45,7.19-.83,11.51-.83,6.96,0,13.05.97,16.49,1.64,0,0,.1,1.31.16,1.99-1.86,1.01-4.27,2.16-7.65,2.16-.26,0-.52,0-.8-.02-4.92-.26-7.64-2.79-11.75-3.01-.23-.01-.46-.02-.68-.02-1.27,0-2.5.19-3.67.53l-3.62-2.45Zm-7.07-3.08c-1.17.25-1.91,1.28-2.03,2.5-.47,5.1-1.59,18.27-1.03,23.55,1.29,11.93,9.81,19.61,20.1,23.42.51.19,1.02.37,1.53.54.12-.04.24-.08.36-.12,0,0,.02,0,.03,0,1.28-.43,2.54-.93,3.76-1.48L11.42,17.06l-1.83-1.36c-.28-.21-.46-.53-.46-.9v-5.66c0-.32.25-.57.56-.57.12,0,.24.04.34.1l4.52,3.41c.29.22.44.56.44.91v2.26c1.89-1.07,4.16-1.6,6.48-1.6.27,0,.54,0,.81.02,4.11.21,6.94,2.96,11.87,3.22.27.01.53.02.78.02,3.55,0,6.06-1.27,7.95-2.32.22,2.89.43,6.09.53,8.98l.05,2.86c-2.24,1.83-5.91,3.43-7.99,3.43-3.46,0-5.81-2.19-9.09-2.19-1.61,0-3.06.48-4.31,1.31l11.57,22.72c1.45-.85,2.83-1.79,4.11-2.83t0,0c5.26-4.25,8.99-10.11,9.81-17.69.57-5.28-.55-18.45-1.02-23.55-.11-1.22-.86-2.25-2.03-2.5-3.21-.67-10.28-2.01-18.57-2.01s-15.37,1.34-18.58,2.01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_122",
    x1: -4782.74,
    y1: 2620.87,
    x2: -4782.06,
    y2: 2620.87,
    gradientTransform: "translate(-204964.73 374080.36) rotate(90) scale(78.21 -78.21)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#fafafa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#eeeded"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#d9d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3c2c2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: -13.9,
    y: -9.85,
    width: 79.04,
    height: 79.04,
    transform: "translate(-13.47 26.81) rotate(-45)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: -7.98,
    y: -4.4,
    width: 68.24,
    height: 67.37,
    transform: "translate(-13.09 30.49) rotate(-50)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 36.46,
    y: 30.46,
    width: 6.93,
    height: 13.9
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 13.8,
    y: 7.28,
    width: 28.62,
    height: 2.36
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 14.37,
    y: 13.63,
    width: 28.5,
    height: 3.89
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 26.79,
    y: 30.51,
    width: 16.57,
    height: 3.9
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 42.24,
    y: 14.57,
    width: 1.27,
    height: 12.46
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 33.01,
    y: 46.71,
    width: 7.11,
    height: 5.59
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 21.44,
    y: 28.95,
    width: 12.19,
    height: 23.35
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 8.04,
    y: 19.45,
    width: 15.81,
    height: 30.87
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 3.52,
    y: 5.76,
    width: 22.41,
    height: 49.97
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 41.77,
    y: 8.99,
    width: 0.81,
    height: 2.62
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 8.66,
    y: 8.57,
    width: 6.35,
    height: 7.3
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: -8.16,
    y: -4.99,
    width: 68.17,
    height: 68.17,
    transform: "translate(-12.98 26.86) rotate(-45)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m58.69,35.07l3.28-1.95c1.09,2.17,3.07,3.37,5.34,3.37,2,0,3.44-.75,3.44-2.27s-1.41-2.14-4-2.86c-3.52-.99-7.2-1.9-7.2-6.04,0-3.69,2.88-5.91,7.13-5.91s6.46,1.95,7.85,4.07l-3.01,2.3c-1.04-1.68-2.94-2.81-4.86-2.81s-2.86.8-2.86,1.98c0,1.58,1.47,2.14,4.06,2.86,3.47.94,7.15,2.03,7.15,6.12,0,3.18-2.4,6.02-7.9,6.02-4.27,0-6.94-2.03-8.41-4.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m79,35.55v-7.11h-2.37v-3.13h2.37v-4.89h4.27v4.89h3.66v3.13h-3.66v6.18c0,1.52.43,2.01,1.97,2.01.48,0,1.12-.05,1.41-.16v3.08c-.32.08-1.89.21-2.83.21-4.22,0-4.83-1.52-4.83-4.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m88.34,35.93c0-3.29,2.78-5.11,9.02-5.62v-.35c0-1.04-.53-1.71-1.92-1.71-1.81,0-3.36.75-4.67,1.77l-1.81-2.46c1.41-1.28,3.55-2.54,7.1-2.54,3.9,0,5.5,1.93,5.5,5.59v5.48c0,1.71.11,2.75.4,3.48h-4.27c-.19-.59-.32-1.28-.32-2.09-1.31,1.47-2.86,2.3-4.96,2.3s-4.06-1.42-4.06-3.85Zm9.02-.62v-2.65c-3.39.35-4.83,1.2-4.83,2.51,0,.91.64,1.36,1.58,1.36,1.49,0,2.53-.51,3.26-1.23Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m104.72,25.31h4.3v2.25c.85-1.12,2.43-2.54,4.91-2.54s4.14,1.2,4.14,4.15v10.4h-4.27v-9.04c0-1.28-.48-1.95-1.68-1.95s-2.13.59-3.1,1.42v9.57h-4.3v-14.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m120.44,32.56c0-4.92,2.27-7.54,5.52-7.54,1.92,0,3.31.7,4.32,2.09v-7.33h4.3v16.31c0,1.71.11,2.75.43,3.48h-4.4c-.19-.35-.32-1.42-.32-2.14-.93,1.28-2.27,2.35-4.38,2.35-3.23,0-5.47-2.3-5.47-7.22Zm9.85,2.59v-5.27c-.93-.88-1.71-1.31-2.83-1.31-1.79,0-2.72,1.36-2.72,3.96,0,2.38.85,4.01,2.78,4.01,1.09,0,2.08-.67,2.78-1.39Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m136.96,35.93c0-3.29,2.78-5.11,9.02-5.62v-.35c0-1.04-.53-1.71-1.92-1.71-1.81,0-3.36.75-4.67,1.77l-1.81-2.46c1.41-1.28,3.55-2.54,7.1-2.54,3.9,0,5.5,1.93,5.5,5.59v5.48c0,1.71.11,2.75.4,3.48h-4.27c-.19-.59-.32-1.28-.32-2.09-1.31,1.47-2.86,2.3-4.96,2.3s-4.06-1.42-4.06-3.85Zm9.02-.62v-2.65c-3.39.35-4.83,1.2-4.83,2.51,0,.91.64,1.36,1.58,1.36,1.49,0,2.53-.51,3.26-1.23Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m153.32,25.31h4.3v2.38h.03c.77-1.2,2.13-2.67,4.8-2.67h.13l-.05,3.82c-.16-.03-.85-.08-1.12-.08-1.71,0-2.99.91-3.79,1.95v8.85h-4.3v-14.25Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m163.86,32.56c0-4.92,2.27-7.54,5.52-7.54,1.92,0,3.31.7,4.32,2.09v-7.33h4.3v16.31c0,1.71.11,2.75.43,3.48h-4.4c-.19-.35-.32-1.42-.32-2.14-.93,1.28-2.27,2.35-4.38,2.35-3.23,0-5.47-2.3-5.47-7.22Zm9.85,2.59v-5.27c-.93-.88-1.71-1.31-2.83-1.31-1.79,0-2.72,1.36-2.72,3.96,0,2.38.85,4.01,2.78,4.01,1.09,0,2.08-.67,2.78-1.39Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m187.89,19.95h4.31v19.69h-4.31v-19.69Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m196.09,25.46h4.28v2.24c.85-1.12,2.42-2.53,4.9-2.53s4.12,1.2,4.12,4.12v10.35h-4.26v-8.99c0-1.28-.48-1.94-1.68-1.94s-2.13.59-3.09,1.41v9.53h-4.28v-14.18Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m210.83,25.46h4.42l2.98,9.45h.05l2.98-9.45h4.02l-5.06,14.21h-4.31l-5.08-14.21Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m226.1,32.57c0-5.51,4.2-7.4,7.13-7.4s6.52,1.46,6.52,7.9v.64h-9.39c.21,2.34,1.52,3.25,3.3,3.25,1.68,0,3.25-.83,4.2-1.7l1.65,2.55c-1.65,1.41-3.7,2.13-6.17,2.13-3.7,0-7.24-1.89-7.24-7.37Zm9.82-1.38c-.21-2-1.12-2.95-2.71-2.95-1.33,0-2.47.88-2.79,2.95h5.51Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m241.19,37.76l1.7-2.39c1.28,1.12,3.19,1.84,4.92,1.84,1.33,0,2.26-.45,2.26-1.38,0-.98-.74-1.36-2.69-1.7-2.69-.48-5.56-1.12-5.56-4.44,0-2.85,2.34-4.5,5.51-4.5,2.9,0,4.66.74,6.23,2l-1.68,2.42c-1.44-.98-2.85-1.54-4.18-1.54-1.22,0-1.92.48-1.92,1.25,0,.85.77,1.2,2.53,1.52,2.79.48,5.75,1.12,5.75,4.34,0,3.43-2.98,4.79-6.25,4.79s-5.19-.96-6.63-2.18Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m257.58,35.65v-7.08h-2.37v-3.11h2.37v-4.87h4.26v4.87h3.65v3.11h-3.65v6.15c0,1.52.43,2,1.97,2,.48,0,1.12-.05,1.41-.16v3.06c-.32.08-1.89.21-2.82.21-4.2,0-4.82-1.52-4.82-4.18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardClogo);
export default __webpack_public_path__ + "static/media/STANDARD_clogo.07a1c0c70a604dfe99b46a99469175e8.svg";
export { ForwardRef as ReactComponent };